var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.role)?_c('div',[_c('RoleHeader',{attrs:{"title":_vm.role.name}}),_c('div',{staticClass:"p-16 space-y-8"},[_c('RoleInfo',{attrs:{"role":_vm.role}}),_c('RolePermissions',{attrs:{"role":_vm.role}})],1),_c('div',[_c('RouterView',{attrs:{"name":"modal"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }